<template>
  <div class="area-switch">
    <div class="area-switch-shadow" @click="hidePopup"></div>
    <div class="area-switch-main">
      <p class="main-title">{{ letter.areaLimitSwitchRegion }}</p>
      <div class="main-content">
        <div class="main-form-box">
          <div class="main-form-box-item">
            <p>{{ letter.selectCountry }}</p>
            <div class="main-select" @click="showAreaSelect">
              <span>{{ nextLocationName || curLocationName }}</span>
              <em class="lang-switch-ico-sanjiao"></em>
            </div>
          </div>
          <div class="main-form-box-item">
            <p>{{ letter.areaLimitCurrency }}</p>
            <Select class="main-select" v-model="nextCurrency">
              <template slot="option">
                <option
                  v-for="item in locationCurrencyList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </template>
              <template slot="ico">
                <em class="lang-switch-ico-sanjiao"></em>
              </template>
            </Select>
          </div>
        </div>
        <template v-if="nextLocationVal === 'US'">
          <div class="main-form-box">
            <div class="main-form-box-item">
              <p>{{ letter.zipCodeState }}</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextStateName"
                :options="usStateOptions"
                @select="selectState"
              ></DataList>
            </div>
            <div class="main-form-box-item">
              <p>zipcode</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextZipCode"
                :options="zipCodeOptions"
                @change="zipcodeChange"
                type="number"
              ></DataList>
            </div>
          </div>
          <p v-if="nextLocationVal === 'US'" class="main-tax-tips">
            {{ `${letter.zipCodeRate}:${curTaxRate}%` }}
          </p>
          <p v-if="!zipCodeValidor" class="main-tips">
            {{ letter.areaLimitEnterInvalid }}
          </p>
        </template>
        <p
          v-html="
            letter.areaLimitRemainingSwitches.replace(
              '\${times}',
              `<span class='main-tips'>${modifyCount}</span>`
            )
          "
        ></p>
        <template v-if="nextLocationVal === 'US'">
          <p>{{ letter.areaLimitTaxRateTips }}</p>
          <!-- 还没有多语言，暂时写死英语，后续可替换为已有的对应多语言 -->
          <p
            @click="jumpAreaLimitPolicy"
            v-html="
              letter.areaLimitInfoCollect.replace(
                '\${policy}',
                `<span class='area-switch-popup-link'>[Privacy Policy]</span>`
              )
            "
          ></p>
        </template>
        <div class="main-btn-wrap">
          <a
            class="confirm btn"
            href="javascript:;"
            @click="submitAreaSwithInfo('V2')"
          >
            {{ letter.areaLimitConfirmSwitch }}
          </a>
        </div>
        <a href="javascript:;" class="main-close" @click="hidePopup"></a>
      </div>
    </div>
    <transition name="fade">
      <AreaSelecter
        v-if="showAreaSelector"
        v-on:closeSelecter="showAreaSelector = false"
        v-on:hideAreaSelector="hideAreaSelector"
        :curLocationsVal="nextLocationVal"
        v-bind:showChildSelector="showAreaSelector"
        :locations="locations"
      ></AreaSelecter>
    </transition>
  </div>
</template>

<script>
import AreaSelecter from '@components/officialWebStore/paytype/AreaSelecter';
import areaLimit from '@mixins/areaLimit';
import zipcode from '@mixins/officialWebStore/zipcode';
import { mapState } from 'vuex';
import { GET_LOCATION_CURRENCY_LIST } from '@store/officialWebStore';
export default {
  name: 'AreaSwitchPopup',
  props: ['zipCode'],
  mixins: [areaLimit, zipcode],
  data() {
    return {
      nextZipCode: '',
      isEditZipCode: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount,
      defaultCurrency: state => state.defaultCurrency
    }),
    modifyCount() {
      return this.maxLocationModifyCount
        ? this.maxLocationModifyCount - this.locationModifyCount
        : 0;
    },
    zipCodeOptions() {
      return this.currentZipCodeList.filter(item =>
        item.value.includes(this.nextZipCode)
      );
    },
    usStateOptions() {
      const US_STATES = this.getUsStateOptions();
      return US_STATES.filter(item => {
        return item.label
          .toUpperCase()
          .includes(this.nextStateName.toUpperCase());
      });
    }
  },
  methods: {
    getLocationCurrencyList(locationCode, isInit = false) {
      this.$store
        .dispatch(GET_LOCATION_CURRENCY_LIST, { location_code: locationCode })
        .then(res => {
          this.locationCurrencyList = res.data;
          if (!isInit) {
            this.nextCurrency = this.locationCurrencyList?.[0];
          }
        });
    },
    // 选择美国州
    selectState(curState) {
      this.nextZipCode = '';
      this.nextStateName = curState.label;
      this.nextStateCode = curState.value;
      this.getZipCodeList(curState.value);
    },
    async zipcodeChange() {
      await this.zipCodeValidorFunc();
    }
  },
  created() {
    this.getLocationCurrencyList(this.nextLocationVal, true);
    this.nextCurrency = this.defaultCurrency;
    this.nextZipCode = this.zipCode || this.ipZipCode || '';
    this.zipCodeValidorFunc();
  },
  watch: {
    nextLocationVal(val) {
      this.getLocationCurrencyList(val, false);
    },
    nextZipCode(val) {
      if (val && val !== this.ipZipCode) {
        this.isEditZipCode = true;
      }
    }
  },
  components: {
    AreaSelecter
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.area-switch {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 660px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }
}
.main {
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
  &-title {
    font-size: 26px;
    text-align: center;
    line-height: 86px;
    height: 86px;
    @include g-popup-title();
    border-radius: 10px 10px 0 0;
    margin: 0;
  }
  &-content {
    font-size: 24px;
    text-align: start;
    padding: 40px 32px;
    margin-bottom: 120px;
    line-height: 1.5;
  }
  &-content-title {
    font-size: 28px;
    line-height: 36px;
    font-weight: bold;
    margin-bottom: 36px;
  }
  &-select {
    box-sizing: border-box;
    width: 100%;
    position: relative;
    margin: 10px 10px 10px 0;
    padding: 0 20px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 6px;
    border: solid 2px #d2d2d2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    cursor: pointer;
    ::v-deep .select {
      padding: 0 20px !important;
    }
    ::v-deep .select-icon {
      right: 0;
    }
  }
  &-btn-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn {
      width: 244px;
      height: 80px;
      border-radius: 9px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 28px;
      color: #fff;
      border-radius: 10px;
      padding: 0 10px;
      cursor: pointer;
    }
    .confirm {
      background: $btnBg;
    }
  }
  &-form-box {
    display: flex;

    &-item {
      width: 50%;
      box-sizing: border-box;
    }
    &-item + &-item {
      margin-left: 10px;
    }
  }
  &-tax-tips {
    float: right;
    width: 50%;
  }
}
.lang-switch {
  &-ico-sanjiao {
    position: absolute;
    top: 50%;
    right: 25px;
    transform: translateY(-50%);
    display: inline-block;
    width: 17px;
    height: 10px;
    background: url($tmslgImg + 'lang-sanjiao.png') no-repeat;
  }
}

::v-deep .datalist-input {
  font-size: 22px;
}
</style>
<style lang="scss">
.main-tips {
  color: #d25f27;
}
.area-switch-popup-link {
  color: #3b90f3;
  cursor: pointer;
  text-decoration: underline;
}
</style>
